import React from "react";
import LegalLayout, { Section, InlineLink } from "@/pages/LegalLayout";

const About = () => (
  <LegalLayout
    title="O nás"
    metaTitle="O nás | SANVIORO — úklid kanceláří a firem v Brně"
    description="SANVIORO — moderní značka profesionálních úklidových služeb pro firmy, kanceláře, provozovny a správu objektů v Brně a okolí. Spolehlivý servis, rychlá komunikace."
    path="/o-nas"
  >
    <p className="text-[#333333]">
      SANVIORO je moderní značka profesionálních úklidových služeb se
      zaměřením na firmy, kanceláře, provozovny a správu objektů v Brně
      a okolí.
    </p>
    <p className="text-[#333333]">
      Naším cílem je poskytovat spolehlivý servis, rychlou komunikaci
      a dlouhodobě kvalitní výsledky bez zbytečných komplikací pro klienta.
    </p>

    <Section title="Co nabízíme">
      <ul className="list-disc pl-6 space-y-2 marker:text-[#0F5C69]">
        <li>Pravidelný úklid kanceláří</li>
        <li>Úklid firemních prostor</li>
        <li>Úklid společných prostor</li>
        <li>Generální úklid</li>
        <li>Individuální řešení dle provozu klienta</li>
      </ul>
    </Section>

    <Section title="Proč SANVIORO">
      <ul className="list-disc pl-6 space-y-2 marker:text-[#0F5C69]">
        <li>Profesionální přístup</li>
        <li>Individuální plán úklidu</li>
        <li>Flexibilní spolupráce</li>
        <li>Důraz na kvalitu</li>
        <li>Působnost Brno a okolí</li>
      </ul>
    </Section>

    <Section title="Kontaktujte nás">
      <ul className="space-y-2">
        <li>
          Telefon:{" "}
          <InlineLink external to="tel:+420775601254">
            +420 775 601 254
          </InlineLink>
        </li>
        <li>
          E-mail:{" "}
          <InlineLink external to="mailto:info@sanvioro.cz">
            info@sanvioro.cz
          </InlineLink>
        </li>
      </ul>
      <p className="pt-2">
        Nezávazná kalkulace a další informace na{" "}
        <InlineLink to="/">domovské stránce</InlineLink>. Zpracování osobních
        údajů popisují{" "}
        <InlineLink to="/ochrana-osobnich-udaju">
          zásady ochrany osobních údajů
        </InlineLink>{" "}
        a pravidla spolupráce upravují{" "}
        <InlineLink to="/obchodni-podminky">obchodní podmínky</InlineLink>.
      </p>
    </Section>

    <Section title="Údaje o společnosti">
      <ul className="space-y-1">
        <li><strong>Sanvioro s.r.o.</strong></li>
        <li>IČO: 29637066</li>
        <li>Sídlo: Příkop 843/4, Zábrdovice, 602 00 Brno, Česká republika</li>
      </ul>
    </Section>
  </LegalLayout>
);

export default About;
